import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CDIsotype } from './BrandMark';
export function CTA() {
  return <section id="contacto" className="relative w-full border-t border-ink/[0.07] bg-white py-28 sm:py-32 lg:py-40" data-id="element-44" data-mp="1ljdxq27znusi">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-45" data-mp="1uh7utfdkusgq">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative overflow-hidden rounded-4xl border border-ink/[0.07] bg-paper-alt px-8 py-20 text-center shadow-soft sm:px-20 sm:py-28" data-id="element-46" data-mp="1ufwqneg7zip3">
          <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
          background: 'radial-gradient(60% 110% at 50% 0%, rgba(37,99,246,0.12), transparent 62%), radial-gradient(55% 100% at 50% 110%, rgba(122,77,255,0.12), transparent 60%)'
        }} data-id="element-47" data-mp="1bp575k2iqbwz" />
          <svg aria-hidden="true" viewBox="0 0 100 100" preserveAspectRatio="none" className="pointer-events-none absolute inset-0 h-full w-full" data-id="element-48" data-mp="38cojaiknqw2s">
            <defs data-id="element-49" data-mp="3h4qeo2fvdm67">
              <linearGradient id="ctaArc" x1="0" y1="1" x2="1" y2="0" data-id="element-50" data-mp="3h59yxpszsmne">
                <stop offset="0%" stopColor="#2563FF" data-id="element-51" data-mp="2kgkf3txt1jys" />
                <stop offset="100%" stopColor="#8B5CF6" data-id="element-52" data-mp="2khvivtr92rpw" />
              </linearGradient>
            </defs>
            <g fill="none" stroke="url(#ctaArc)" vectorEffect="non-scaling-stroke" opacity="0.22" data-id="element-53" data-mp="2tg775p4n9df6">
              <circle cx="12" cy="18" r="26" strokeWidth="1" data-id="element-54" data-mp="2yglh5cpt2xfu" />
              <circle cx="90" cy="86" r="22" strokeWidth="1" data-id="element-55" data-mp="8qrmlbw0qkxz" />
            </g>
          </svg>

          <div className="relative mx-auto max-w-2xl" data-id="element-56" data-mp="do9wb4hv1471">
            <span className="mx-auto grid h-12 w-12 place-items-center rounded-2xl border border-ink/[0.07] bg-white shadow-soft" data-id="element-57" data-mp="dqw1wyl6x9mm">
              <CDIsotype className="h-6 w-6 text-ink" data-id="element-58" data-mp="25r5hm1h39zer" />
            </span>
            <h2 className="mt-8 text-3xl font-semibold leading-[1.15] tracking-[-0.025em] text-ink sm:text-[2.9rem]" data-id="element-59" data-mp="25sytpwah1bu5">
              Empezá hoy a construir un negocio más inteligente.
            </h2>
            <p className="mx-auto mt-7 max-w-xl text-[16px] font-light leading-relaxed text-ink-soft" data-id="element-60" data-mp="2ephe2k4mzrf4">
              Recursos, estrategias e inteligencia artificial en un solo lugar.
              Elegí tu producto y empezá a implementar esta semana.
            </p>
            <a href="#productos" className="group brand-gradient-bg mt-12 inline-flex items-center gap-2 rounded-full px-7 py-4 text-sm font-medium text-white shadow-[0_24px_54px_-20px_rgba(90,80,246,0.75)] transition-all duration-300 hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric/50" data-id="element-61" data-mp="20t3yjgjny03a">
              Ver Productos
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-62" data-mp="3ey63jhjo096y" />
            </a>
            <p className="mt-8 text-[12.5px] font-light text-ink-muted" data-id="element-63" data-mp="360ndfyr5z4o7">
              creativodigital.shop · @creativodigitalstudio
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}